import { Link, useParams } from 'react-router';

import { ROUTES } from '#/config/routes';
import { fetchStockReturnDetail } from '#/api/imsMgmt/receipts/stockReturn/fetchDetail';
import { updateStockReturnRemark } from '#/api/imsMgmt/receipts/stockReturn/updateRemark';
import { Button } from '#/modules/commonComponents/button';
import PageShell from '#/modules/infra/layout/PageShell';
import useDocumentRemarkSave from '#/hooks/useDocumentRemarkSave';
import DocumentRemarkEditForm from '#/modules/imsMgmt/receipts/shared/DocumentRemarkEditForm';
import StockReturnMainInfoCard from '#/modules/imsMgmt/receipts/stockReturn/components/StockReturnMainInfoCard';
import {
  getStockReturnApiErrorMessage,
  isStockReturnVersionConflict,
} from '#/modules/imsMgmt/receipts/stockReturn/helper/apiError';
import { canEditStockReturnRemark } from '#/modules/imsMgmt/receipts/stockReturn/helper/returnStatus';
import {
  stockReturnDetailQueryKey,
  stockReturnListQueryKeyPrefix,
} from '#/utils/queryKeys';

const StockReturnRemarkPage = () => {
  const { id } = useParams();

  const {
    detail,
    detailQuery,
    isPending,
    saveRemark,
  } = useDocumentRemarkSave({
    id,
    fetchDetail: fetchStockReturnDetail,
    updateRemark: updateStockReturnRemark,
    detailQueryKey: stockReturnDetailQueryKey,
    listQueryKeyPrefix: stockReturnListQueryKeyPrefix,
    getErrorMessage: (error) => getStockReturnApiErrorMessage(error, '更新備註失敗'),
    isVersionConflict: isStockReturnVersionConflict,
    afterSaveNavigateTo: ROUTES.workOrderReturnDetail(id),
  });

  const isLoading = detailQuery.isLoading;
  const isError = detailQuery.isError;
  const remarkAllowed = detail ? canEditStockReturnRemark(detail.status) : false;

  return (
    <PageShell variant="form">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div className="create_edit_page__header">
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">編輯退料備註</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.workOrderReturnDetail(id)}>返回詳情</Link>
            </Button>
          </div>

          {isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {isError ? (
            <p className="text-sm text-destructive">
              {getStockReturnApiErrorMessage(detailQuery.error, '找不到退料單')}
            </p>
          ) : null}

          {detail && !remarkAllowed ? (
            <div className="space-y-3">
              <p className="text-sm text-slate-600">此狀態不可編輯備註。</p>
              <Button type="button" asChild>
                <Link to={ROUTES.workOrderReturnDetail(id)}>前往詳情</Link>
              </Button>
            </div>
          ) : null}

          {detail && remarkAllowed ? (
            <>
              <StockReturnMainInfoCard detail={detail} />
              <DocumentRemarkEditForm
                initialRemark={detail.remark ?? ''}
                cancelTo={ROUTES.workOrderReturnDetail(id)}
                isPending={isPending}
                onSave={saveRemark}
              />
            </>
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default StockReturnRemarkPage;
